//* NF | IRRITALK
export const frRenamingAuditsAsCheckList = {
    'navbar.audits': 'Check-list',
    'audits.name': 'Check-list',
    'audits.type.Manual': 'Check-list',
    'audits.history.title': 'Check-list',

    'audits.list.header.theme.title': 'THEMES DE CHECK-LIST',
    'audits.list.header.history.title': 'HISTORIQUE CHECK-LIST',
    'audits.header.analysis.title': 'ANALYSE THEMES',

    'audits.history.list.pageTitle': 'Check-list',
    'audits.history.list.table.emptyLabel': "Il n'y a pas de check-list pour le moment",

    'audits.analysis.table.header.title.number': 'Nbre de check-list',
    'audits.analysis.region.question.table.header.nbaudits': 'Nbre de check-list',
    'audits.analysis.theme.question.table.header.nbaudits': 'Nbre de check-list',
    'audits.analysis.theme.shop.table.header.nbaudits': 'Nbre de check-list',
    'audits.analysis.region.theme.section.title': 'Détail des check-list',

    'audits.details.actions.previous': 'Check-list',
    'audits.details.info.title': "Titre de la check-list *",

    'backofficeUsers.create.tabs.permissions.sectionTabs.audits': 'Check-list',
    'backofficeUsers.permissions.audits.managethemetag': 'Création de tags pour les check-list',

};
